import { render, staticRenderFns } from "./PersonCourse.vue?vue&type=template&id=563f9802&scoped=true&"
import script from "./PersonCourse.vue?vue&type=script&lang=js&"
export * from "./PersonCourse.vue?vue&type=script&lang=js&"
import style0 from "./PersonCourse.vue?vue&type=style&index=0&id=563f9802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f9802",
  null
  
)

export default component.exports